import { render } from "./RowsPerPageDropdown.vue?vue&type=template&id=3a68d364"
import script from "./RowsPerPageDropdown.vue?vue&type=script&lang=js"
export * from "./RowsPerPageDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script